import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'na-meta-search-footer',
  templateUrl: './meta-search-footer.component.html',
  styleUrls: ['./meta-search-footer.component.scss']
})
export class MetaSearchFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  backToTop(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  }

  redirectTo(): void {
    window.open('https://navigating.art/', "_blank");
  }
}
